import { createSlice } from '@reduxjs/toolkit'
import { initialList, createReducers } from '../helpers'
import ProfileThumb from '../../assets/images/profile-thumb.png'


export const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    messages: initialList([
      {
        id: Date.now(),
        type: 'image',
        sender: {
          id: Date.now(),
          avatar: ProfileThumb
        },
        src: ProfileThumb,
        createdAt: new Date().toISOString()
      }
    ]),
    coversations: initialList()
  },
  reducers: createReducers('SET', 'PUSH'),
})

// Actions
export const msgActions = messagesSlice.actions

// Getters
export const messagesSelector = state => state.messages.messages

export default messagesSlice.reducer